import { createBrowserHistory } from 'history';
import { envConfig } from './env_config';

export default createBrowserHistory({ basename: envConfig.publicUrl });
